import React from "react";
import { getCurrentLanguage, getLanguages } from '../../assets/js/functions';

const Head = () => {
  return  <ul className="lang is-flex gap-3 is-size-3 link-dn is-flex-shrink-0">
    <li>
      <a
        title="Versión en español"
        hrefLang="es-ES"
        lang="es-ES"
        href="/simbologia/es/"
      >
        {getCurrentLanguage() === 'es'?
        <span className="has-text-weight-bold">ES</span>
        :
        <>ES</>
        }
      </a>
    </li>
    <li>
      {/* <span className="has-text-weight-bold">EU</span> */}
      <a
        title="Euskarazko bertsioa"
        hrefLang="eu-ES"
        lang="eu-ES"
        href="/simbologia/eu/"
      >
        {getCurrentLanguage() === 'eu'?
        <span className="has-text-weight-bold">EU</span>
        :
        <>EU</>
        }
      </a>
    </li>
  </ul>;
};

export default Head;
